import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";
import { BLOGS } from "@/constants/content";

export default function LatestBlogsPreview() {
  return (
    <section className="section bg-white" data-testid="blogs-section">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div className="max-w-xl">
            <div className="eyebrow mb-3">Latest Blogs</div>
            <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
              Learn from our <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">clinical team</span>.
            </h2>
          </div>
          <Link to="/blogs" className="inline-flex items-center gap-1 text-sm font-semibold text-[#0A84FF] hover:gap-2 transition-all">
            All blogs <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {BLOGS.map((b, i) => (
            <motion.div
              key={b.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="group rounded-2xl overflow-hidden border border-slate-200/70 bg-white hover:shadow-xl hover:-translate-y-1 transition-all"
              data-testid={`blog-card-${i}`}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-[11px] text-slate-500">
                  <Calendar className="h-3 w-3" />
                  {new Date(b.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                  {b.tags?.[0] && (
                    <>
                      <span>·</span>
                      <span className="font-medium" style={{ color: '#0A84FF' }}>{b.tags[0]}</span>
                    </>
                  )}
                </div>
                <h3 className="mt-3 font-display font-semibold text-slate-900 leading-snug group-hover:text-[#0A84FF] transition-colors">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 line-clamp-2 leading-relaxed">{b.excerpt}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
